import { useMutation } from '@apollo/client';
import { UpdateProductCategoryAndTagsMutation, UpdateProductCategoryAndTagsMutationVariables } from '_graphql/mutation/__generated__/graphql';
// import {
//   UpdateProductCategoryAndTags,
//   UpdateProductCategoryAndTagsVariables,
// } from '_graphql/mutation/__generated__/UpdateProductCategoryAndTags';
import { UPDATE_PRODUCT_CATEGORIES_AND_TAG } from '_graphql/mutation/products';

export const useUpdateProductCategoriesAndTag = (
  variables?: UpdateProductCategoryAndTagsMutationVariables
) => {
  const [updateProductCategoryAndTag, { ...rest }] = useMutation<
    UpdateProductCategoryAndTagsMutation,
    UpdateProductCategoryAndTagsMutationVariables
  >(UPDATE_PRODUCT_CATEGORIES_AND_TAG, {
    variables,
    refetchQueries: ['GetProduct'],
  });
  return {
    ...rest,
    updateProductCategoryAndTag,
  };
};
